import script from "./ListaOrdini.vue?vue&type=script&setup=true&lang=js"
export * from "./ListaOrdini.vue?vue&type=script&setup=true&lang=js"

import "./ListaOrdini.vue?vue&type=style&index=0&id=e0013ac2&scoped=true&lang=css"

import exportComponent from "C:\\Users\\adria\\OneDrive\\Escritorio\\whappy-app-front-vue-v2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e0013ac2"]])

export default __exports__